import { render, staticRenderFns } from "./NextEpisode.vue?vue&type=template&id=0a5d2d53&scoped=true"
import script from "./NextEpisode.vue?vue&type=script&lang=js"
export * from "./NextEpisode.vue?vue&type=script&lang=js"
import style0 from "./NextEpisode.vue?vue&type=style&index=0&id=0a5d2d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d2d53",
  null
  
)

export default component.exports